<div class="card">
  @if (svg(); as _svg) {
    <pai-svg
      class="card__code"
      [class.card__code--loading]="isLoading()"
      (transitionend)="svgTransitionEnd.next()"
      [url]="_svg"
    />
  }
  <h3 class="card__title">{{ data().title }}</h3>

  <div class="card__actions">
    <button
      pai-button
      type="button"
      minWidth="23mm"
      [appearance]="currency() === 'CHF' ? 'primary' : 'secondary'"
      (click)="useChf()"
    >
      CHF
    </button>
    <button
      pai-button
      type="button"
      minWidth="23mm"
      [appearance]="currency() === 'EUR' ? 'primary' : 'secondary'"
      (click)="useEur()"
    >
      EUR
    </button>
  </div>

  <p class="card__text" [innerText]="data().text"></p>
</div>
